import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IMetadataImage } from "../../viewer-components/interfaces/i-metadataimage";
import { IDownloadImageDialogData } from "../../viewer-components/interfaces/i-download-image-dialog-data";

@Component({
  selector: "confirm-download-dialog",
  templateUrl: "./confirm-download-dialog.html",
  styleUrls: ["./confirm-download-dialog.scss"],
  standalone: false,
})
export class ConfirmDownloadDialogComponent {
  exports: number;

  image: IMetadataImage;

  canvas: any;

  dialogData: IDownloadImageDialogData;

  clipDataUrl: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDownloadImageDialogData,
  ) {
    this.dialogData = data;
    this.clipDataUrl = data.canvas ? data.canvas.toDataURL() : null;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
